(async () => {
    const { Core } = await importModule('Core');

    customElements.define('sale-countdown', class extends Core {

        elements = {
            days: '[data-days]',
            hours: '[data-hours]',
            minutes: '[data-minutes]',
            seconds: '[data-seconds]'
        }

        render() {
            this.endDate = new Date(this.getAttribute('end-date'));
            if (isNaN(this.endDate.getTime())) return;
            this._tick();
            this.interval = setInterval(() => this._tick(), 1000);
        }

        disconnectedCallback() {
            clearInterval(this.interval);
        }

        _tick() {
            const diff = this.endDate.getTime() - Date.now();
            if (diff <= 0) {
                clearInterval(this.interval);
                this.hidden = true;
                return;
            }
            this.hidden = false;

            const seconds = Math.floor(diff / 1000) % 60;
            const minutes = Math.floor(diff / (1000 * 60)) % 60;
            const hours = Math.floor(diff / (1000 * 60 * 60)) % 24;
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));

            this.$days.textContent = String(days).padStart(2, '0');
            this.$hours.textContent = String(hours).padStart(2, '0');
            this.$minutes.textContent = String(minutes).padStart(2, '0');
            this.$seconds.textContent = String(seconds).padStart(2, '0');
        }
    })
})();
